import React from "react";
import ArchieveEmployeeList from "../../components/admin/ArchieveEmployee";

const ArchieveEmployeePage = () => {
  return (
    <div>
      <ArchieveEmployeeList />
    </div>
  );
};

export default ArchieveEmployeePage;
